import { useContext } from 'react';
import { Button } from 'reactstrap';
import { AuthenticationContext } from '../../msal/AuthenticationContext';
import { AuthorizationContext } from '../../context/AuthorizationContext';
import { Container, Jumbotron } from 'reactstrap';
import * as Utils from '../../utils/helper'; 

export const Unauthorized = () => {
    const authenticationInfo = useContext(AuthenticationContext);
    const authorizationInfo = useContext(AuthorizationContext);

    const isUserAuthorized = authorizationInfo.detailedAuthorizationState && Utils.isTrue(authorizationInfo.detailedAuthorizationState.isUserAuthorized);

    const renderedUserMessage = isUserAuthorized ? 
        (
            <div>
                <p><strong>Your user is not signed up for the Robin service.</strong></p>
            </div>
        ) :
        (
            <div>
                <p><strong>You are not authorized to use this application. For access you either need the 'Global', 'Application', 'Cloud Application' or 'Teams' administrator role or you must be member of a configured access group. Please contact your administrator.</strong></p>                
                <p>Please note that it can take up to 5 minutes before a group assignment in Microsoft Entra becomes effective in this portal.</p>
            </div>
        )

    return (
        <Container>
            <Jumbotron>
                {renderedUserMessage}
                <p>Click the button below to log-out and log-in with a different user account.</p>
                <Button color="primary" onClick={authenticationInfo.logout}>Logout</Button>
            </Jumbotron>
        </Container>        
    )
}